import React, { useCallback, useRef, useState } from "react";
import { useDropzone } from "react-dropzone";
import * as XLSX from "xlsx";
import { api } from "../../../../Apis/interceptor";
import ToastElement from "../../../../Components/UiComponents/ToastElement";
import Loader from "../../../../Components/UiComponents/Loader";
import { useNavigate } from "react-router-dom";

const FileUploader = ({ handleSave }) => {
  const toastRef = useRef();
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false);

  const onDrop = useCallback((acceptedFiles) => {
    const file = acceptedFiles[0];
    const reader = new FileReader();

    const allTypeFiles = [
      'image/png', 'image/jpeg', 'image/bmp', 'image/svg', 'image/tiff', 'image/gif', 'image/vnd.dwg', 'image/x-dwg', 'image/x-emf', 'image/x-mgx-emf', 'image/x-xbitmap', 'image/x-pict', 'image/x-targa', 'image/x-tga', 'image/x-dpx', 'image/x-jp2', 'image/x-jpf', 'image/photoshop', 'image/x-photoshop', 'image/psd', 'image/x‑portable‑bitmap', 'image/x-jps', 'image/iff', 'image/x-iff', 'image/sgi',
    ]

    reader.onload = async (event) => {
      // const data = new Uint8Array(event.target.result);
      // try {
      //   const workbook = XLSX.read(data, { type: "array" });
      //   const sheetName = workbook.SheetNames[0];
      //   const worksheet = workbook.Sheets[sheetName];
      //   const json = XLSX.utils.sheet_to_json(worksheet);
      // } catch (error) {
      //   toastRef.current.showToast({
      //     type: "error",
      //     message: "Upload correct file",
      //   });
      // }

      try {
        if (allTypeFiles.indexOf(file.type) !== -1) {
          var enduser = localStorage.getItem("enduser")
          if (enduser) {
            var currCustomer = JSON.parse(enduser);
            if (currCustomer) {
              setLoading(true);
              const response = await api.post(
                `/api/v1/uploadCompanyLogo/${currCustomer.customer}`,
                {
                  file: file,
                  customer_id: currCustomer.customer,
                },
                {
                  headers: {
                    "Content-Type": "multipart/form-data",
                  },
                }
              );
              if (response && response.data.error_code == 0) {
                toastRef.current.showToast({
                  type: "success",
                  message: "File Uploaded Successfully",
                });
                // setLoading(false);
              }
              const uploadSurveyEmailLogoResponse = await api.post(`/api/v1/uploadSurveyEmailLogo/${currCustomer.customer}`, {
                file: file,
                customer_id: currCustomer.customer,
              },
                {
                  headers: {
                    "Content-Type": "multipart/form-data",
                  },
                });

              // Handle the response
              if (uploadSurveyEmailLogoResponse && uploadSurveyEmailLogoResponse.data) {
                toastRef.current.showToast({
                  type: 'success',
                  message: "Survey Email Logo Uploaded Successfully"
                });
                // setLoading(false);
              }
              handleSave(file.name)
              setLoading(false);
            } else {
              navigate("/login")
              localStorage.clear()
            }
          }
          setLoading(false);
        } else {
          toastRef.current.showToast({
            type: "error",
            message: "Please upload only image",
          });
        }
      } catch (error) {
        console.error("Error uploading file:", error);
      }
    };

    reader.readAsArrayBuffer(file);
  }, []);

  const { getRootProps, getInputProps } = useDropzone({ onDrop });

  return (
    <div {...getRootProps()} style={dropzoneStyle}>
      <ToastElement ref={toastRef} />
      <Loader loading={loading} />
      <input {...getInputProps()} />
      <i className="pi pi-upload"></i>
      <p>Drag 'n' drop an Image file here, or click to select one</p>
    </div>
  );
};

const dropzoneStyle = {
  border: "2px dashed #cccccc",
  borderRadius: "5px",
  padding: "20px",
  textAlign: "center",
  cursor: "pointer",
};

export default FileUploader;
